import React from "react";
import Store from "../../content/Store";
import styles from "../../assets/css/modules/cover/cover-add-a-plan-link.css";
import { Link } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";
import Contentify from "../../content/Contentify";

export const CoverAddAPlanLink = ({ content }) => (
  <React.Fragment>
    <div className={styles.addAPlanLink + " row"}>
      <div className="col-12">
        <h3>{content.title}</h3>
        <Link to={Paths.AddAPlan}>{content.description}</Link>
      </div>
    </div>
  </React.Fragment>
);

CoverAddAPlanLink.content = Store.AddAPlanLink;

export default Contentify(CoverAddAPlanLink);
